import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';

export const styles = StyleSheet.create({
  base: {
    display: 'flex',
    marginHorizontal: indent * 0.5,
    width: '95%',
  },
});
